// ** React Imports
import { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { AxiosInterceptor } from "@configs/axios";
import { queryClient } from "@configs/reactQuery";

// ** Redux Imports
import { store } from "./redux/store";
import { Provider } from "react-redux";

// ** Intl, CASL & ThemeColors Context
import ability from "./configs/acl/ability";
import { AbilityContext } from "./utility/context/Can";
import { ThemeContext } from "./utility/context/ThemeColors";

// ** ThemeConfig
import themeConfig from "./configs/themeConfig";

// ** Toast
import { Toaster } from "react-hot-toast";

// ** React query
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

// ** i18n
import "./configs/i18n";

// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner";

// ** Ripple Button
import "./@core/components/ripple-button";

// ** PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-jsx.min";

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";

// ** React Hot Toast Styles
import "@styles/react/libs/react-hot-toasts/react-hot-toasts.scss";

import "@styles/react/libs/react-toastify/react-toastify.scss";
// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";

// ** Service Worker
import * as serviceWorker from "./serviceWorker";
// import TestSentry from "./TestSentry";

import CustomErrorBoundary from "@features/error/components/CustomErrorBoundry";
// import { SENTRY_DSN } from "./configs";
// import * as Sentry from "@sentry/react";
import {Bounce, ToastContainer} from "react-toastify";

import { SkeletonTheme } from 'react-loading-skeleton';


// Sentry.init({
//   dsn: "https://5c9d558d8b645fc56dcbc9f73d2c5222@o4508793197494272.ingest.de.sentry.io/4508793212633168",
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   tracesSampleRate: 1.0,
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
// });

// ** Lazy load app
const LazyApp = lazy(() => import("./App"));

const queryConfig = {
  queries: {
    useErrorBoundary: true,
    refetchOnWindowFocus: false,
    retry: false,
  },
};

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Suspense fallback={<Spinner />}>
          <AxiosInterceptor>
            <AbilityContext.Provider value={ability}>
              <ThemeContext>
                <CustomErrorBoundary>
                  <SkeletonTheme baseColor="#202020" highlightColor="#444">

                  <LazyApp />
                  {/*<Toaster*/}
                  {/*  position={themeConfig.layout.toastPosition}*/}
                  {/*  toastOptions={{ className: "react-hot-toast", duration:100000,*/}
                  {/*    success: {*/}
                  {/*      iconTheme: {*/}
                  {/*        primary: '#008767',*/}
                  {/*      },*/}
                  {/*    },*/}
                  {/*  }}*/}
                  {/*/>*/}
                  <ToastContainer
                      className="toast-position"
                      position="top-right"
                      autoClose={5000}
                      hideProgressBar
                      newestOnTop={false}
                      closeOnClick={false}
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      theme="dark"
                      transition={Bounce}
                      closeButton={false}
                  />
                  </SkeletonTheme>
                </CustomErrorBoundary>
              </ThemeContext>
            </AbilityContext.Provider>
          </AxiosInterceptor>
        </Suspense>
      </Provider>
    </QueryClientProvider>
  </BrowserRouter>
);

// root.render(<TestSentry />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
